
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  CreatePricingPlanRequest,
  PricingPlanResource,
} from '../models';
import {
    CreatePricingPlanRequestFromJSON,
    CreatePricingPlanRequestToJSON,
    PricingPlanResourceFromJSON,
    PricingPlanResourceToJSON,
} from '../models';

export interface CreatePricingRequest {
    createPricingPlanRequest: CreatePricingPlanRequest;
}

/**
 * 
 */
export class PricingPlanApi extends runtime.BaseAPI {

    /**
     * POST client-settings/api/pricings
          */
    async createPricingRaw(requestParameters: CreatePricingRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['createPricingPlanRequest'] == null) {
            throw new runtime.RequiredError(
                'createPricingPlanRequest',
                'Required parameter "createPricingPlanRequest" was null or undefined when calling createPricing().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/client-settings/api/pricings`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePricingPlanRequestToJSON(requestParameters['createPricingPlanRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * POST client-settings/api/pricings
          */
    async createPricing(requestParameters: CreatePricingRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.createPricingRaw(requestParameters, initOverrides);
    }

    /**
     * GET client-settings/api/pricings
          */
    async findAllPricingRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<PricingPlanResource>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<PricingPlanResource>>({
            path: `/client-settings/api/pricings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(PricingPlanResourceFromJSON);
        return response;
    }

    /**
     * GET client-settings/api/pricings
          */
    async findAllPricing(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<PricingPlanResource>> {
        const response = await this.findAllPricingRaw(initOverrides);
        return response._data;
    }

}
